// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","1677":"c403d866","2690":"0fcba4fa"}[chunkId] + ".chunk.css";
};